<template>
    <spinner-until :condition="participantLoaded">
        <participant-menu>
            <div class="my-lifestyle">
                <b-row>
                    <b-col cols="12">
                        <b-card no-body>
                            <b-card-header v-if="!showParticipantMenuAsAccordion">
                                <h5>
                                        <span class="icon-wrapper icon-wrapper-left">
                                            <shs-icon name="heart"></shs-icon>
                                        </span>
                                    {{ $i18n.gt('HEADING_MY_LIFESTYLE') }}
                                </h5>
                            </b-card-header>
                            <b-card-body class="light-bg">
                                <b-row :cols="$mq == 'sm' || $mq == 'md' ? 1 : null">
                                    <report-widget widget-key="SCORE_EXER"></report-widget>
                                    <report-widget widget-key="SCORE_DIET"></report-widget>
                                    <report-widget widget-key="SCORE_STRESS"></report-widget>
                                    <report-widget widget-key="SCORE_SLEEP"></report-widget>
                                </b-row>
                                <b-row class="mb-0 mt-3" :cols="$mq == 'sm' || $mq == 'md' ? 1 : null">
                                    <report-widget widget-key="TOTAL_SCORE">
                                        <report-total-score-light></report-total-score-light>
                                    </report-widget>
                                </b-row>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </participant-menu>
    </spinner-until>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>

import Vue from 'vue'
import PatientPageMixin from '@/providers/PatientPageMixin'
import ReportMixin from '@/providers/ReportMixin'

/**
 * Page to display gauges for a Participant's lifestyle-related scores
 *
 * NB: the SCORE_DIET widget will display both diet scores if they exist - unlike in the provider views,
 * we do not have easy access to the practice and the use_dietid_questionnaire setting.
 * In most cases, however the patient will only have one type of diet score, depending on the practice
 * setting. In the worst case, where a patient belongs to multiple practices with different settings,
 * there might be legit reasons to display both scores.
 */
export default Vue.extend({
    name: 'MyLifestyle',
    mixins: [PatientPageMixin, ReportMixin],
})

</script>
